import React from "react";
import Slider from "react-slick";
import home1 from "../assets/images/beauty2.avif";
import home2 from "../assets/images/beauty3.avif";
import home3 from "../assets/images/beauty4.avif";

export default function SpotlightSlider() {
  const settings = {
    dots: true,
    arrows: true,
    infinite: true,
    speed: 700,
    autoplay: true,
    autoplaySpeed: 2500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  return (
    <>
   
      <Slider {...settings} className="mb-4">
        {[home1, home2, home3].map((img, i) => (
          <div key={i} className="text-center">
            <img
              src={img}
              alt={`spotlight-${i}`}
              className="img-fluid w-100"
              style={{ height: "300px", objectFit: "contain", borderRadius: "15px" }}
            />
          </div>
        ))}
      </Slider>
    </>
  );
}
